  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //-------------------
  // @material-ui/icons
  //-------------------
//import CardTravel                                          from "@material-ui/icons/CardTravel";
//import Extension                                           from "@material-ui/icons/Extension";
//import Fingerprint                                         from "@material-ui/icons/Fingerprint";
//import FlightLand                                          from "@material-ui/icons/FlightLand";
//import Build                                               from "@material-ui/icons/Build";
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
  //------
  // Style
  //------
  import CustomerConfirmStyle                                from "./CustomerConfirmStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "CustomerConfirm ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var CustomerConfirm_continue_locked = true;

  //[flagsimages]
  var images = null;

class CustomerConfirm extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "",               //4279034659
      textField0_hasError                                  : false,

      countryResidence_id                                  : "",               //DropDown
      countryResidence_text                                : "",
      countryResidence_hasError                            : false,
      countryResidence_AUTOCOMPLETE_MODE                   : "object", //"text","object";
      countryResidence_AUTOCOMPLETE_FILTER_OPTIONS         : "any",    //"start","any"
      cityResidence                                        : "",               //TextField
      cityResidence_hasError                               : false,
      homeAddress                                          : "",               //TextField
      homeAddress_hasError                                 : false,
      postalCode                                           : "",               //TextField
      postalCode_hasError                                  : false,
      phonePrefix_id                                       : "",               //DropDown
      email                                                : "",               //TextField
      email_disabled                                       : false,
      email_hasError                                       : false,
      phonePrefix_text                                     : "",
      phonePrefix_hasError                                 : false,
      phonePrefix_AUTOCOMPLETE_MODE                        : "object", //"text","object";
      phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS              : "any",    //"start","any"
      phoneNumber                                          : "",               //TextField
      phoneNumber_hasError                                 : false,
      isMobile                                             : false,            //CheckBox
      profession_id                                        : "",               //DropDown
      profession_text                                      : "",
      profession_hasError                                  : false,
      positionLevel_id                                     : "",               //DropDown
      positionLevel_text                                   : "",
      positionLevel_hasError                               : false,
      positionLevel_isHidden                               : true,
      textField6                                           : "",               //TextField-OTP
      textField6_hasError                                  : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],
      parserObject_getProfessions4Picker                   : [],
      parserObject_getPositionLevel                        : [],

      last_updateMobileTriggerOTP_timestamp                : null,

      btn_next_state                                       : "",

      //popup successConfirm
      dialog_successConfirm_msg                            : "",
      dialog_successConfirm_isOpen                         : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.resendCodeButton_btnClick                                    = this.resendCodeButton_btnClick.bind(this);
    this.resendCodeButton_btnClick_isDisabled                         = this.resendCodeButton_btnClick_isDisabled.bind(this);

    this.btn_save_act                                                = this.btn_save_act.bind(this);
    this.btn_save_act_isDisabled                                     = this.btn_save_act_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                                 = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                = React.createRef();

    this.handleCustomDropDownClick_countryResidence                  = this.handleCustomDropDownClick_countryResidence.bind(this);
    this.handleCustomDropDownClick_phonePrefix                       = this.handleCustomDropDownClick_phonePrefix.bind(this);
    this.handleCustomDropDownClick_profession                        = this.handleCustomDropDownClick_profession.bind(this);
    this.handleCustomDropDownClick_positionLevel                     = this.handleCustomDropDownClick_positionLevel.bind(this);

    //popup successConfirm
    this.dialog_successConfirm_handleOpen                            = this.dialog_successConfirm_handleOpen.bind(this);
    this.dialog_successConfirm_btn_add                               = this.dialog_successConfirm_btn_add.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //[Lockers]
    this.stopLockers();

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="RegisterLight3"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      return;
    }

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    this.setState({
      "btn_next_state" : this.NSInforString("CustomerConfirm_btn_verify")
    //"btn_next_state" : this.NSInforString("CustomerConfirm_btn_save")
    });

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker = [];
        //res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    var res_obj = wu_StaticDataService.wu_getPhonePrefixes({});
    var parserObject_getPhonePrefixes4Picker = [];
    for(var i=0; i<res_obj.phone_prefixes.length; ++i){ parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]); }
    this.setState({
      "parserObject_getPhonePrefixes"        : res_obj.phone_prefixes,
      "parserObject_getPhonePrefixes4Picker" : parserObject_getPhonePrefixes4Picker
    });
    //-----------------
    //wu_getProfessions---STATIC
    //-----------------
    let res_obj_getProfessions = wu_StaticDataService.wu_getProfessions({});
    let parserObject_getProfessions4Picker_el = [];
    let parserObject_getProfessions4Picker_en = [];
    let descKey_professions_el = "descr_el";
    let descKey_professions_en = "descr_en";
    let professions_sorted_el = JSON.parse(JSON.stringify(res_obj_getProfessions.professions));
    let professions_sorted_en = JSON.parse(JSON.stringify(res_obj_getProfessions.professions));
    professions_sorted_el.sort(function(a, b) {
      if( (a.descr_el).localeCompare(b.descr_el) === -1){ return -1; }
      if( (a.descr_el).localeCompare(b.descr_el) === 1){ return 1; }
      return 0;
    });
    professions_sorted_en.sort(function(a, b) {
      if( (a.descr_en).localeCompare(b.descr_en) === -1){ return -1; }
      if( (a.descr_en).localeCompare(b.descr_en) === 1){ return 1; }
      return 0;
    });
    for(let i=0; i<professions_sorted_el.length; ++i){ parserObject_getProfessions4Picker_el.push(professions_sorted_el[i][descKey_professions_el]); }
    for(let i=0; i<professions_sorted_en.length; ++i){ parserObject_getProfessions4Picker_en.push(professions_sorted_en[i][descKey_professions_en]); }
    this.setState({
      "parserObject_getProfessions_el"        : professions_sorted_el,
      "parserObject_getProfessions_en"        : professions_sorted_en,
      "parserObject_getProfessions4Picker_el" : parserObject_getProfessions4Picker_el,
      "parserObject_getProfessions4Picker_en" : parserObject_getProfessions4Picker_en,
      "profession_id"                         : "",
      "profession_text"                       : "",
      "profession_hasError"                   : false,
    });
    //if(api.print_logs){console.log("parserObject_getProfessions4Picker_el="+parserObject_getProfessions4Picker_el);}
    //if(api.print_logs){console.log("parserObject_getProfessions4Picker_en="+parserObject_getProfessions4Picker_en);}
    //-------------------
    //wu_getPositionLevel---STATIC
    //-------------------
    var res_obj_getPositionLevel = wu_StaticDataService.wu_getPositionLevel({});
    var parserObject_getPositionLevel4Picker_el = [];
    var parserObject_getPositionLevel4Picker_en = [];
    let descKey_positionLevel_el = "descr_el";
    let descKey_positionLevel_en = "descr_en";
    for(let i=0; i<res_obj_getPositionLevel.positions.length; ++i){ parserObject_getPositionLevel4Picker_el.push(res_obj_getPositionLevel.positions[i][descKey_positionLevel_el]); }
    for(let i=0; i<res_obj_getPositionLevel.positions.length; ++i){ parserObject_getPositionLevel4Picker_en.push(res_obj_getPositionLevel.positions[i][descKey_positionLevel_en]); }
    this.setState({
      "parserObject_getPositionLevel"           : res_obj_getPositionLevel.positions,
      "parserObject_getPositionLevel4Picker_el" : parserObject_getPositionLevel4Picker_el,
      "parserObject_getPositionLevel4Picker_en" : parserObject_getPositionLevel4Picker_en,
      "positionLevel_id"                        : "",
      "positionLevel_text"                      : "",
      "positionLevel_hasError"                  : false,
    });
    //-------------------
    //wu_validatecustomer
    //-------------------
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let ws_countryResidence = "";
      let ws_city             = "";
      let ws_address          = "";
      let ws_post_code        = ""
      let ws_email            = "";;
      let ws_phone            = "";
      let ws_isMobile         = 0;
      let ws_profession       = "";
      let ws_positionLevelId  = 0;
      try {ws_countryResidence = res.customer["countryResidence"]; }catch(err){;} if(ws_countryResidence === null || (typeof ws_countryResidence ==="undefined")){ws_countryResidence = "";}
      try {ws_city             = res.customer["city"];             }catch(err){;} if(ws_city             === null || (typeof ws_city             ==="undefined")){ws_city             = "";}
      try {ws_address          = res.customer["address"];          }catch(err){;} if(ws_address          === null || (typeof ws_address          ==="undefined")){ws_address          = "";}
      try {ws_post_code        = res.customer["post_code"];        }catch(err){;} if(ws_post_code        === null || (typeof ws_post_code        ==="undefined")){ws_post_code        = "";}
      try {ws_email            = res.customer["email"];            }catch(err){;} if(ws_email            === null || (typeof ws_email            ==="undefined")){ws_email            = "";}
      try {ws_phone            = res.customer["phone"];            }catch(err){;} if(ws_phone            === null || (typeof ws_phone            ==="undefined")){ws_phone            = "";}
      try {ws_isMobile         = res.customer["isMobile"];         }catch(err){;} if(ws_isMobile         === null || (typeof ws_isMobile         ==="undefined")){ws_isMobile         = 0; }
      try {ws_profession       = res.customer["profession"];       }catch(err){;} if(ws_profession       === null || (typeof ws_profession       ==="undefined")){ws_profession       = "";}
      try {ws_positionLevelId  = res.customer["positionLevelId"];  }catch(err){;} if(ws_positionLevelId  === null || (typeof ws_positionLevelId  ==="undefined")){ws_positionLevelId  = "";}

      let phonePrefix = "";
      let phoneNumber = "";
      try {phonePrefix = ws_phone.split("-")[0]; }catch(err){;} if(phonePrefix === null || (typeof phonePrefix ==="undefined")){phonePrefix = "";}
      try {phoneNumber = ws_phone.split("-")[1]; }catch(err){;} if(phoneNumber === null || (typeof phoneNumber ==="undefined")){phoneNumber = "";}

      if(ws_post_code==="00000"){
        ws_post_code = "";
      }

      this.setState({
        countryResidence_id                                  : ws_countryResidence,
        countryResidence_text                                : this.state.countryResidence_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_countryResidence,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_countryResidence,localStorage.getItem("lang")),
        countryResidence_hasError                            : false,
        cityResidence                                        : ws_city,
        homeAddress                                          : ws_address,
        postalCode                                           : ws_post_code,
        email                                                : ws_email,
        email_disabled                                       : false,
        phonePrefix_id                                       : phonePrefix,
        phonePrefix_text                                     : this.state.phonePrefix_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findPhonePrefixNameFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")) : wu_Utilities.findPhonePrefixObjFromPhonePrefixId(phonePrefix,localStorage.getItem("lang")),
        phonePrefix_hasError                                 : false,
        phoneNumber                                          : phoneNumber,
        isMobile                                             : (ws_isMobile===1 || ws_isMobile==="1") ? true : false,
        profession_id                                        : ws_profession,
        profession_text                                      : wu_Utilities.findProfessionNameFromProfessionId(ws_profession,localStorage.getItem("lang")),
        profession_hasError                                  : false,
        positionLevel_id                                     : ws_positionLevelId+"",
        positionLevel_text                                   : wu_Utilities.findPositionlevelNameFromPositionlevelId(ws_positionLevelId+"",localStorage.getItem("lang")),
        positionLevel_hasError                               : false,
        positionLevel_isHidden                               : this.get_positionLevel_isHidden(ws_profession),
      });
    })
    .catch(err => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //----------------
    //CountryResidence
    //----------------
    let defaultPropsCountryResidence  = {};
    let filterOptionsCountryResidence = {};
    if(this.state.countryResidence_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountryResidence  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountryResidence = createFilterOptions({matchFrom: this.state.countryResidence_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountryResidence = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountryResidence = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountryResidence = createFilterOptions({matchFrom: this.state.countryResidence_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }
    //-----------
    //PhonePrefix
    //-----------
    let defaultPropsPhonePrefix   = {};
    let filterOptionsPhonePrefix  = {};
    if(this.state.phonePrefix_AUTOCOMPLETE_MODE === "text"){
      defaultPropsPhonePrefix   = { options:this.state.parserObject_getPhonePrefixes4Picker, getOptionLabel:option => option, };
      filterOptionsPhonePrefix  = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsPhonePrefix = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      else                                   { defaultPropsPhonePrefix = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      filterOptionsPhonePrefix = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr + option.keywords,});
    }

    let btn_next_state_TMP = (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify") ? this.NSInforString("CustomerConfirm_btn_verify") : this.NSInforString("CustomerConfirm_btn_save");

    var lang = localStorage.getItem("lang");
    var parserObject_getProfessions4Picker   = (lang==="el") ? this.state.parserObject_getProfessions4Picker_el   : this.state.parserObject_getProfessions4Picker_en;
    var parserObject_getPositionLevel4Picker = (lang==="el") ? this.state.parserObject_getPositionLevel4Picker_el : this.state.parserObject_getPositionLevel4Picker_en;
    var profession_text                      = this.translate_profession(   lang,this.state.profession_id,   this.state.profession_text);
    var positionLevel_text                   = this.translate_positionLevel(lang,this.state.positionLevel_id,this.state.positionLevel_text);
    //console.log(methName+"lang                          = "+lang);
    //console.log(methName+"this.state.profession_id      = "+this.state.profession_id);
    //console.log(methName+"this.state.profession_text    = "+this.state.profession_text);
    //console.log(methName+"profession_text               = "+profession_text);
    //console.log(methName+"this.state.positionLevel_id   = "+this.state.positionLevel_id);
    //console.log(methName+"this.state.positionLevel_text = "+this.state.positionLevel_text);
    //console.log(methName+"positionLevel_text            = "+positionLevel_text);

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("CustomerConfirm_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("CustomerConfirm_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <div>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{this.NSInforString("CustomerConfirm_lbl_info1")}</div><br/>
                  {/* <div className={classes.label2}>{this.NSInforString("CustomerConfirm_lbl_info2")}</div><br/> */}
                </GridItem>
              </GridContainer>

              <GridContainer justify="center">
                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete={this.autoCompleteText_Textfields()}
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>

                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                {this.state.countryResidence_AUTOCOMPLETE_MODE === "text" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.countryResidence}>
                    <Autocomplete
                      {...defaultPropsCountryResidence}
                      id="countryResidence"
                      value={this.state.countryResidence_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_countryResidence(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.countryResidence_hasError} label={this.NSInforString("CustomerConfirm_plh01")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.countryResidence}>
                    <Autocomplete
                      filterOptions={filterOptionsCountryResidence}
                      {...defaultPropsCountryResidence}
                      id="countryResidence"
                      value={this.state.countryResidence_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_countryResidence(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.countryResidence_hasError} label={this.NSInforString("CustomerConfirm_plh01")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) }
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.cityResidence_hasError}
                    className={classes.cityResidence}
                    id="cityResidence"
                    label={this.NSInforString("CustomerConfirm_plh02")}
                    value={this.state.cityResidence}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "cityResidence"),
                      type: "text"
                    }}
                  />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.homeAddress_hasError}
                    className={classes.homeAddress}
                    id="homeAddress"
                    label={this.NSInforString("CustomerConfirm_plh03")}
                    value={this.state.homeAddress}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "homeAddress"),
                      type: "text"
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.postalCode_hasError}
                    className={classes.postalCode}
                    id="postalCode"
                    label={this.NSInforString("CustomerConfirm_plh04")}
                    value={this.state.postalCode}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "postalCode"),
                      type: "text"
                    }}
                  />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error   ={this.state.email_hasError}
                    disabled={this.state.email_disabled}
                    className={classes.email}
                    id="email"
                    label={this.NSInforString("CustomerConfirm_plh05")}
                    value={this.state.email}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "email"),
                      type: "email"
                    }}
                  />
                  <div className={classes.label_emailInfo}>{this.NSInforString("CustomerConfirm_emailInfo_lbl_lbl1")}</div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                {this.state.phonePrefix_AUTOCOMPLETE_MODE === "text" ? (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.phonePrefix}>
                    <Autocomplete
                      {...defaultPropsPhonePrefix}
                      id="phonePrefix"
                      value={this.state.phonePrefix_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.phonePrefix_hasError} label={this.NSInforString("CustomerConfirm_plh06")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) : (
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.phonePrefix}>
                    <Autocomplete
                      filterOptions={filterOptionsPhonePrefix}
                      {...defaultPropsPhonePrefix}
                      id="phonePrefix"
                      value={this.state.phonePrefix_text}
                      disableClearable
                      onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option.descr)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.phonePrefix_hasError} label={this.NSInforString("CustomerConfirm_plh06")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                ) }
                <GridItem xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    error={this.state.phoneNumber_hasError}
                    className={classes.phoneNumber}
                    id="phoneNumber"
                    label={this.NSInforString("CustomerConfirm_plh07b")}
                    value={this.state.phoneNumber}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "phoneNumber"),
                      type: "text"
                    }}
                  />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.profession_hasError} className={classes.profession}>
                    <InputLabel id="profession_InputLabel">{this.NSInforString("CustomerConfirm_plh08")}</InputLabel>
                    <Select
                      MenuProps={{ classes: { paper: classes.menuPaper } }}
                      displayEmpty
                      id="profession"
                      value={profession_text+""}
                      onChange={event => this.handleCustomDropDownClick_profession(event)}
                    >
                      {parserObject_getProfessions4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                {this.state.positionLevel_isHidden === true ? ( "" ) : (
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={this.state.positionLevel_hasError} className={classes.positionLevel}>
                      <InputLabel id="positionLevel_InputLabel">{this.NSInforString("CustomerConfirm_plh08b")}</InputLabel>
                      <Select
                        displayEmpty
                        id="positionLevel"
                        value={positionLevel_text+""}
                        onChange={event => this.handleCustomDropDownClick_positionLevel(event)}
                      >
                        {parserObject_getPositionLevel4Picker.map(function (akey) {
                          return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                )}
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      error={this.state.textField6_hasError}
                      className={classes.textField6}
                      id="textField6"
                      value={this.state.textField6}
                      label={this.NSInforString("CustomerConfirm_plh09")}
                      defaultValue=""
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField6"), type: "text"  }}
                    />
                  </GridItem>
                ) : ( "" )}

                { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.CustomerConfirm_info2}>{this.NSInforString("CustomerConfirm_info2")}</div>
                </GridItem>
                ) : ( "" )}

                { (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false ? (
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <Button
                      disabled={this.resendCodeButton_btnClick_isDisabled()}
                      className={classes.resendCodeButton}
                      color="default"
                      onClick={this.resendCodeButton_btnClick}
                      type="submit">
                      {this.NSInforString("CustomerConfirm_btn_resend")}
                    </Button>
                  </div>
                </GridItem>
                ) : ( "" )}

              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    {/* <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_save_act } /> */}
                    <CustomButton
                      disabled={this.btn_save_act_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_save_act}
                      type="submit">
                      {btn_next_state_TMP}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP successConfirm]-------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_successConfirm_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_successConfirm_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_successConfirm_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_successConfirm} color="default" onClick={this.dialog_successConfirm_btn_add}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_countryResidence(event,value) {
    let methName = filename+"handleCustomDropDownClick_countryResidence ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.countryResidence_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({ "btn_next_state" : this.NSInforString("CustomerConfirm_btn_verify"), });
    this.setState({ "countryResidence_text":eventTMP1 });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "countryResidence_id"       : this.state.parserObject_getCountries[i].ctry_wu_id,
          "countryResidence_hasError" : false,
          //
          "cityResidence"                                        : "",
          "cityResidence_hasError"                               : false,
          "homeAddress"                                          : "",
          "homeAddress_hasError"                                 : false,
          "postalCode"                                           : "",
          "postalCode_hasError"                                  : false,
          "phoneNumber"                                          : "",
          "phoneNumber_hasError"                                 : false,
        });

        let ctry_wu_id = this.state.parserObject_getCountries[i].ctry_wu_id;
        for(let j=0; j<this.state.parserObject_getPhonePrefixes.length; ++j){
          if(this.state.parserObject_getPhonePrefixes[j].ctry_wu_id===ctry_wu_id){
            this.setState({
              "phonePrefix_id"       : this.state.parserObject_getPhonePrefixes[j].c2c_wu_id,
              "phonePrefix_text"     : this.state.parserObject_getPhonePrefixes[j].descr,
              "phonePrefix_hasError" : false,
            });
            break;
          }
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_phonePrefix(event,value) {
    let methName = filename+"handleCustomDropDownClick_phonePrefix ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.phonePrefix_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "phonePrefix_text"     : eventTMP1,
      "phonePrefix_hasError" : false,
      "btn_next_state"       : this.NSInforString("CustomerConfirm_btn_verify"),
    });
    for(let i=0; i<this.state.parserObject_getPhonePrefixes4Picker.length; ++i){
      if(this.state.parserObject_getPhonePrefixes4Picker[i]===eventTMP2){
        this.setState({ "phonePrefix_id":this.state.parserObject_getPhonePrefixes[i].c2c_wu_id });
        //console.log('this.state.parserObject_getPhonePrefixes[i].c2c_wu_id='+this.state.parserObject_getPhonePrefixes[i].c2c_wu_id);
        if(this.state.parserObject_getPhonePrefixes[i].c2c_wu_id!=="30"){
          this.setState({"phoneNumber_hasError" : false });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_isMobile(event) {
    let methName = filename+"handleCheckBoxClick_isMobile ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "isMobile":  event.target.checked });

    if(this.state.phonePrefix_id === "30"){
      let textField4btext = this.state.phoneNumber.trim();
      if(event.target.checked===true){
          if(this.verifyGenericItem("phone_mobile",textField4btext)===false){
            console.log('1 this.state.isMobile='+this.state.isMobile+",textField4btext="+textField4btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
            return;
          }
          else{
              this.setState({"phoneNumber_hasError" : false });
          }
      }
      if(event.target.checked===false){
          if(this.verifyGenericItem("phone_landline",textField4btext)===false){
            console.log('2 this.state.isMobile='+this.state.isMobile+",textField4btext="+textField4btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
            return;
          }
          else{
              this.setState({"phoneNumber_hasError" : false });
          }
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_profession(event) {
    let methName = filename+"handleCustomDropDownClick_profession ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "profession_text"     : eventTMP,
      "profession_hasError" : false,
      "btn_next_state"      : this.NSInforString("CustomerConfirm_btn_verify"),
    });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getProfessions4Picker_el.length; ++i){
        if(this.state.parserObject_getProfessions4Picker_el[i]===eventTMP){
          this.setState({ "profession_id":this.state.parserObject_getProfessions_el[i].profession_wu_id });
          let profession_wu_id_TMP = this.state.parserObject_getProfessions_el[i].profession_wu_id;
          this.setState({ "positionLevel_isHidden":this.get_positionLevel_isHidden(profession_wu_id_TMP) });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getProfessions4Picker_en.length; ++i){
        if(this.state.parserObject_getProfessions4Picker_en[i]===eventTMP){
          this.setState({ "profession_id":this.state.parserObject_getProfessions_en[i].profession_wu_id });
          let profession_wu_id_TMP = this.state.parserObject_getProfessions_en[i].profession_wu_id;
          this.setState({ "positionLevel_isHidden":this.get_positionLevel_isHidden(profession_wu_id_TMP) });
          break;
        }
      }
    }
  }
  get_positionLevel_isHidden(profession_wu_id_TMP){
    if(profession_wu_id_TMP === "Civil/Government Employee"                  ||
       profession_wu_id_TMP === "Law Enforcement/Military Professional"      || //
       profession_wu_id_TMP === "Law Enforcement/Military"                   ||
       profession_wu_id_TMP === "Airline/Maritime Employee"                  ||
       profession_wu_id_TMP === "Art/Entertainment/Media Professional"       || //
       profession_wu_id_TMP === "Art/Entertainment/Media"                    ||
       profession_wu_id_TMP === "Teacher/Educator"                           ||
       profession_wu_id_TMP === "Hotel/Restaurant/Leisure Services Employee" || //
       profession_wu_id_TMP === "Hotel/Restaurant/Leisure"                   ||
       profession_wu_id_TMP === "IT and Tech Professional"                   ||
       profession_wu_id_TMP === "Medical and Health Care Professional"       || //
       profession_wu_id_TMP === "Medical/Health Care"                        ||
       profession_wu_id_TMP === "Cosmetic/Personal Care Services"            || //
       profession_wu_id_TMP === "Cosmetic/Personal Care"                     ||
       profession_wu_id_TMP === "Office Professional"                        ||
       profession_wu_id_TMP === "Retail Sales"                               ||
       profession_wu_id_TMP === "Sales/Insurance/Real Estate Professional"   || //
       profession_wu_id_TMP === "Sales/Insurance/Real Estate"                ||
       profession_wu_id_TMP === "Science/Research Professional"              ||
       profession_wu_id_TMP === "Skilled Trade/Specialist"                   ){
        return false;
    }
    else{
        return true;
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_positionLevel(event) {
    let methName = filename+"handleCustomDropDownClick_positionLevel ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "positionLevel_text"     : eventTMP,
      "positionLevel_hasError" : false,
      "btn_next_state"         : this.NSInforString("CustomerConfirm_btn_verify"),
    });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getPositionLevel4Picker_el.length; ++i){
        if(this.state.parserObject_getPositionLevel4Picker_el[i]===eventTMP){
          this.setState({ "positionLevel_id":this.state.parserObject_getPositionLevel[i].position_wu_id });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getPositionLevel4Picker_en.length; ++i){
        if(this.state.parserObject_getPositionLevel4Picker_en[i]===eventTMP){
          this.setState({ "positionLevel_id":this.state.parserObject_getPositionLevel[i].position_wu_id });
          break;
        }
      }
    }
  }
  translate_profession(lang,profession_id,profession_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getProfessions_el.length; ++i){ if(this.state.parserObject_getProfessions_el[i]["profession_wu_id"]===profession_id){ return this.state.parserObject_getProfessions_el[i]["descr_el"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getProfessions_en.length; ++i){ if(this.state.parserObject_getProfessions_en[i]["profession_wu_id"]===profession_id){ return this.state.parserObject_getProfessions_en[i]["descr_en"] } }
    }
  }
  translate_positionLevel(lang,positionLevel_id,positionLevel_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getPositionLevel.length; ++i){ if(this.state.parserObject_getPositionLevel[i]["position_wu_id"]===positionLevel_id){ return this.state.parserObject_getPositionLevel[i]["descr_el"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getPositionLevel.length; ++i){ if(this.state.parserObject_getPositionLevel[i]["position_wu_id"]===positionLevel_id){ return this.state.parserObject_getPositionLevel[i]["descr_en"] } }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  resendCodeButton_btnClick_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  resendCodeButton_btnClick(event) {
    let methName = filename+"resendCodeButton_btnClick ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.countryResidence_text === "")          { this.setState({"countryResidence_hasError" : true }); emptyFields = true; } //countryResidence_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.cityResidence.trim() === "")           { this.setState({"cityResidence_hasError"    : true }); emptyFields = true; }
      if(this.state.homeAddress.trim() === "")             { this.setState({"homeAddress_hasError"      : true }); emptyFields = true; }
      if(this.state.postalCode.trim() === "")              { this.setState({"postalCode_hasError"       : true }); emptyFields = true; }
      if(this.state.email.trim() === "")                   { this.setState({"email_hasError"            : true }); emptyFields = true; }
      if(this.state.phonePrefix_text === "")               { this.setState({"phonePrefix_hasError"      : true }); emptyFields = true; } //phonePrefix_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber.trim() === "")             { this.setState({"phoneNumber_hasError"      : true }); emptyFields = true; }
      if(this.state.profession_id.trim() === "")           { this.setState({"profession_hasError"       : true }); emptyFields = true; }
      if(this.state.positionLevel_isHidden === false){
        if(this.state.positionLevel_id.trim() === "")      { this.setState({"positionLevel_hasError"    : true }); emptyFields = true; }
      }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.stopLockers();return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //-------------------------
    //validate countryResidence---Picker(validate:id,label)
    //-------------------------
    let countryResidence = this.state.countryResidence_id;
    if(countryResidence === ""){
        this.setState({"countryResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh01"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //----------------------
    //validate cityResidence---TextField
    //----------------------
    let cityResidence  = this.state.cityResidence.trim();
    let textField1text = this.state.cityResidence.trim();
    if(textField1text === ""){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh02")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    let textField1textTMP = this.state.cityResidence.trim();
    textField1textTMP = textField1textTMP.replace(/-/g,"");
    textField1textTMP = textField1textTMP.replace(/,/g,"");
    textField1textTMP = textField1textTMP.replace(/\./g,"");
    textField1textTMP = textField1textTMP.replace(/ /g,"");
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField1textTMP)===false){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh02")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(textField1text.length > 50){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.cityResidence.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //---------------------
    //validate Home Address---TextField
    //---------------------
    let homeAddress    = this.state.homeAddress.trim();
    let textField2text = this.state.homeAddress.trim();
    if(textField2text === ""){
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh03")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    let textField2textTMP = this.state.homeAddress.trim();
    textField2textTMP = textField2textTMP.replace(/-/g,"");
    textField2textTMP = textField2textTMP.replace(/,/g,"");
    textField2textTMP = textField2textTMP.replace(/\./g,"");
    textField2textTMP = textField2textTMP.replace(/ /g,"");
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField2textTMP)===false){ //accept keno,-
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh03")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(textField2text.length > 50){
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.homeAddress.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //--------------------
    //validate Postal Code---TextField
    //--------------------
    let postalCode     = this.state.postalCode.trim();
    let textField3text = this.state.postalCode.trim();
    if(textField3text === ""){
        this.setState({"postalCode_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh04")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField3text.replace(/ /g,""))===false){
        this.setState({"postalCode_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh04")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //--------------
    //validate email---TextField
    //--------------
    let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
  //let email          = this.state.email.trim();
    let textField4text = this.state.email.trim();
    if(textField4text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh05")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    if(this.verifyGenericItem("email",textField4text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone       = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField5text  = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField5btext = this.state.phoneNumber.trim();
    if(api.print_logs){console.log("this.state.phonePrefix_id = "+this.state.phonePrefix_id);}
    if(api.print_logs){console.log("this.state.phoneNumber    = "+this.state.phoneNumber);}
    if(textField5text === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.setState({"phoneNumber_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh07b")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === "30"){
        if(textField5btext.length !== 10){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
        if(this.verifyGenericItem("phone_mobile",textField5btext)===false){
            console.log('1 this.state.isMobile='+this.state.isMobile+",textField5btext="+textField5btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    else{
      //if(textField5btext.length < 10 || textField5btext.length>24){
        if(textField5btext.length < 7 || textField5btext.length>24){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    //-------------------
    //validate profession---Picker
    //-------------------
    let profession = this.state.profession_id;
    if(profession  === ""){
      this.setState({"profession_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh08"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //----------------------
    //validate positionLevel---Picker
    //----------------------
    let positionLevel = "";
    if(this.state.positionLevel_isHidden === false){
        positionLevel = this.state.positionLevel_id;
        if(positionLevel  === ""){
          this.setState({"positionLevel_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh08b"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers();return;
        }
    }
    //------------
    //validate OTP
    //------------
    /*let textField6text   = this.state.textField6.trim();
    let verificationCode = this.state.textField6.trim();
    if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      if(textField6text === ""){
        this.setState({"textField6_hasError" : true });
      //this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("CustomerConfirm_plh09"));
        this.dialog_handleOpen(this.NSInforString("CustomerConfirm_msg_empty_SMS"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers(); return;
      }
      if(this.verifyGenericItem("8digitregisterpin",textField6text)===false){
          this.dialog_handleOpen(this.NSInforString("8digitpinregister"));
          //if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
          this.stopLockers();return;
      }
    }*/
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //++++++++
    //Continue
    //++++++++
  //event.preventDefault();
    let parserObject_customerConfirmData_req = {};
    parserObject_customerConfirmData_req["homeAddress"]       = homeAddress;      //SWROU 11
    parserObject_customerConfirmData_req["postalCode"]        = postalCode;       //
    parserObject_customerConfirmData_req["cityResidence"]     = cityResidence;    //
    parserObject_customerConfirmData_req["countryResidence"]  = countryResidence; //
    parserObject_customerConfirmData_req["mobile"]            = telephone;        //6912345678
    parserObject_customerConfirmData_req["email"]             = emailBase64;      //
    parserObject_customerConfirmData_req["profession"]        = profession;       //UNEMPLOYED
    parserObject_customerConfirmData_req["Position_Level_id"] = positionLevel;    //1,2,3
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-------------------------
      //wu_updateMobileTriggerOTP---resend
      //-------------------------
      wu_ProfileService
      .wu_updateMobileTriggerOTP({mobile:telephone})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();
        this.setState({ "btn_next_state":this.NSInforString("CustomerConfirm_btn_save") });
        this.setState({ "last_updateMobileTriggerOTP_timestamp":new Date() });
        this.dialog_handleOpen(this.NSInforString("CustomerConfirm_msg_info_SMS").replace("[phone number]", telephone));
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500)
  }
  //----------------------------------------------------------------------------------------------------
  btn_save_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.countryResidence_text === "")          { this.setState({"countryResidence_hasError" : true }); emptyFields = true; } //countryResidence_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.cityResidence.trim() === "")           { this.setState({"cityResidence_hasError"    : true }); emptyFields = true; }
      if(this.state.homeAddress.trim() === "")             { this.setState({"homeAddress_hasError"      : true }); emptyFields = true; }
      if(this.state.postalCode.trim() === "")              { this.setState({"postalCode_hasError"       : true }); emptyFields = true; }
      if(this.state.email.trim() === "")                   { this.setState({"email_hasError"            : true }); emptyFields = true; }
      if(this.state.phonePrefix_text === "")               { this.setState({"phonePrefix_hasError"      : true }); emptyFields = true; } //phonePrefix_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber.trim() === "")             { this.setState({"phoneNumber_hasError"      : true }); emptyFields = true; }
      if(this.state.profession_id.trim() === "")           { this.setState({"profession_hasError"       : true }); emptyFields = true; }
      if(this.state.positionLevel_isHidden === false){
        if(this.state.positionLevel_id.trim() === "")      { this.setState({"positionLevel_hasError"    : true }); emptyFields = true; }
      }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_save_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  btn_save_act(event) {
    let methName = filename+"btn_save_act ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.countryResidence_text === "")          { this.setState({"countryResidence_hasError" : true }); emptyFields = true; } //countryResidence_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.cityResidence.trim() === "")           { this.setState({"cityResidence_hasError"    : true }); emptyFields = true; }
      if(this.state.homeAddress.trim() === "")             { this.setState({"homeAddress_hasError"      : true }); emptyFields = true; }
      if(this.state.postalCode.trim() === "")              { this.setState({"postalCode_hasError"       : true }); emptyFields = true; }
      if(this.state.email.trim() === "")                   { this.setState({"email_hasError"            : true }); emptyFields = true; }
      if(this.state.phonePrefix_text === "")               { this.setState({"phonePrefix_hasError"      : true }); emptyFields = true; } //phonePrefix_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber.trim() === "")             { this.setState({"phoneNumber_hasError"      : true }); emptyFields = true; }
      if(this.state.profession_id.trim() === "")           { this.setState({"profession_hasError"       : true }); emptyFields = true; }
      if(this.state.positionLevel_isHidden === false){
        if(this.state.positionLevel_id.trim() === "")      { this.setState({"positionLevel_hasError"    : true }); emptyFields = true; }
      }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.stopLockers();return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //-------------------------
    //validate countryResidence---Picker(validate:id,label)
    //-------------------------
    let countryResidence = this.state.countryResidence_id;
    if(countryResidence === ""){
        this.setState({"countryResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh01"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //----------------------
    //validate cityResidence---TextField
    //----------------------
    let cityResidence  = this.state.cityResidence.trim();
    let textField1text = this.state.cityResidence.trim();
    if(textField1text === ""){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh02")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    let textField1textTMP = this.state.cityResidence.trim();
    textField1textTMP = textField1textTMP.replace(/-/g,"");
    textField1textTMP = textField1textTMP.replace(/,/g,"");
    textField1textTMP = textField1textTMP.replace(/\./g,"");
    textField1textTMP = textField1textTMP.replace(/ /g,"");
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField1textTMP)===false){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh02")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(textField1text.length > 50){
        this.setState({"cityResidence_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.cityResidence.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //---------------------
    //validate Home Address---TextField
    //---------------------
    let homeAddress    = this.state.homeAddress.trim();
    let textField2text = this.state.homeAddress.trim();
    if(textField2text === ""){
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh03")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    let textField2textTMP = this.state.homeAddress.trim();
    textField2textTMP = textField2textTMP.replace(/-/g,"");
    textField2textTMP = textField2textTMP.replace(/,/g,"");
    textField2textTMP = textField2textTMP.replace(/\./g,"");
    textField2textTMP = textField2textTMP.replace(/ /g,"");
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField2textTMP)===false){ //accept keno,-
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh03")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(textField2text.length > 50){
        this.setState({"homeAddress_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.homeAddress.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //--------------------
    //validate Postal Code---TextField
    //--------------------
    let postalCode     = this.state.postalCode.trim();
    let textField3text = this.state.postalCode.trim();
    if(textField3text === ""){
        this.setState({"postalCode_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh04")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(wu_Utilities.offline_validate_latinAlphaNumeric(textField3text.replace(/ /g,""))===false){
        this.setState({"postalCode_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh04")+"\" "+this.NSInforString("with_latin"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    //--------------
    //validate email---TextField
    //--------------
    let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
  //let email          = this.state.email.trim();
    let textField4text = this.state.email.trim();
    if(textField4text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh05")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    if(this.verifyGenericItem("email",textField4text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone       = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField5text  = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField5btext = this.state.phoneNumber.trim();
    if(api.print_logs){console.log("this.state.phonePrefix_id = "+this.state.phonePrefix_id);}
    if(api.print_logs){console.log("this.state.phoneNumber    = "+this.state.phoneNumber);}
    if(textField5text === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.setState({"phoneNumber_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("CustomerConfirm_plh07b")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === "30"){
        if(textField5btext.length !== 10){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
        if(this.verifyGenericItem("phone_mobile",textField5btext)===false){
            console.log('1 this.state.isMobile='+this.state.isMobile+",textField5btext="+textField5btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    else{
      //if(textField5btext.length < 10 || textField5btext.length>24){
        if(textField5btext.length < 7 || textField5btext.length>24){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();return;
        }
    }
    //-------------------
    //validate profession---Picker
    //-------------------
    let profession = this.state.profession_id;
    if(profession  === ""){
      this.setState({"profession_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh08"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //----------------------
    //validate positionLevel---Picker
    //----------------------
    let positionLevel = "";
    if(this.state.positionLevel_isHidden === false){
        positionLevel = this.state.positionLevel_id;
        if(positionLevel  === ""){
          this.setState({"positionLevel_hasError" : true });
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("CustomerConfirm_plh08b"));
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers();return;
        }
    }
    //------------
    //validate OTP
    //------------
    let textField6text   = this.state.textField6.trim();
    let verificationCode = this.state.textField6.trim();
    if( (this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify")===false){
      if(textField6text === ""){
        this.setState({"textField6_hasError" : true });
      //this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("CustomerConfirm_plh09"));
        this.dialog_handleOpen(this.NSInforString("CustomerConfirm_msg_empty_SMS"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers(); return;
      }
      if(this.verifyGenericItem("8digitregisterpin",textField6text)===false){
          this.dialog_handleOpen(this.NSInforString("8digitpinregister"));
          //if(shouldResetCaptcha){this.recaptchaRef_send.reset();}
          this.stopLockers();return;
      }
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers();return;
    }
    //++++++++
    //Continue
    //++++++++
  //event.preventDefault();
    let parserObject_customerConfirmData_req = {};
    parserObject_customerConfirmData_req["homeAddress"]       = homeAddress;      //SWROU 11
    parserObject_customerConfirmData_req["postalCode"]        = postalCode;       //
    parserObject_customerConfirmData_req["cityResidence"]     = cityResidence;    //
    parserObject_customerConfirmData_req["countryResidence"]  = countryResidence; //
    parserObject_customerConfirmData_req["mobile"]            = telephone;        //6912345678
    parserObject_customerConfirmData_req["email"]             = emailBase64;      //
    parserObject_customerConfirmData_req["profession"]        = profession;       //UNEMPLOYED
    parserObject_customerConfirmData_req["Position_Level_id"] = positionLevel;    //1,2,3

    if(this.state.btn_next_state==="Επαλήθευση" || this.state.btn_next_state==="Verify"){
      if(this.shouldAllow_updateMobileTriggerOTP(this.state.last_updateMobileTriggerOTP_timestamp)===false){
        this.dialog_handleOpen(this.NSInforString("CustomerConfirm_msg_wait_for_retry"));
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();return;
      }
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //-------------------------
        //wu_updateMobileTriggerOTP
        //-------------------------
        wu_ProfileService
        .wu_updateMobileTriggerOTP({mobile:telephone})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopLockers();this.stopSpinners();
          this.setState({ "btn_next_state":this.NSInforString("CustomerConfirm_btn_save") });
          this.setState({ "last_updateMobileTriggerOTP_timestamp":new Date() });
          this.dialog_handleOpen(this.NSInforString("CustomerConfirm_msg_info_SMS").replace("[phone number]", telephone));
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      }.bind(this), 500);
    }
    else{
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //------------------------
        //wu_updateMobileVerifyOTP
        //------------------------
        wu_ProfileService
        .wu_updateMobileVerifyOTP({verificationCode:verificationCode})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopLockers();this.stopSpinners();
          //----------------------
          //wu_customerConfirmData
          //----------------------
          wu_ProfileService
          .wu_customerConfirmData(parserObject_customerConfirmData_req)
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            //this.stopLockers();this.stopSpinners();

            wu_ProfileService
            .wu_validatecustomer({})
            .then(res => {
              if(localStorage.getItem("curr_view").trim()!=="CustomerConfirm"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
              if(shouldResetCaptcha){this.recaptchaRef.reset();}
              localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

              this.dialog_successConfirm_handleOpen(this.NSInforString("CustomerConfirm_msg_success"),"NET");
            })
            .catch(err => {
              if(shouldResetCaptcha){this.recaptchaRef.reset();}
              this.stopLockers();this.stopSpinners();
              console.log(methName+"err="+JSON.stringify(err));
              if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
              else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
            })
          })
          .catch(err => {
            if(shouldResetCaptcha){this.recaptchaRef.reset();}
            this.stopLockers();this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      }.bind(this), 500);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="email"){
      this.setState({
        "email"               : eventTMP,
        "email_hasError"      : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"      : this.NSInforString("CustomerConfirm_btn_verify"),
      });
      //if(eventTMP.length>0 && wu_Utilities.wu_verifyEmail(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"email_hasError":true}); return; }
    }
    else if(stateVar==="cityResidence"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "cityResidence"          : eventTMP,
        "cityResidence_hasError" : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"         : this.NSInforString("CustomerConfirm_btn_verify"),
      });
      //accept [keno][-][,][.]
      eventTMP = eventTMP.replace(/-/g,"");
      eventTMP = eventTMP.replace(/,/g,"");
      eventTMP = eventTMP.replace(/\./g,"");
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"cityResidence_hasError":true}); return; }
    }
    else if(stateVar==="homeAddress"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "homeAddress"          : eventTMP,
        "homeAddress_hasError" : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"       : this.NSInforString("CustomerConfirm_btn_verify"),
      });
      //accept [keno][-][,][.]
      eventTMP = eventTMP.replace(/-/g,"");
      eventTMP = eventTMP.replace(/,/g,"");
      eventTMP = eventTMP.replace(/\./g,"");
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"homeAddress_hasError":true}); return; }
    }
    else if(stateVar==="postalCode"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "postalCode"          : eventTMP,
        "postalCode_hasError" : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"      : this.NSInforString("CustomerConfirm_btn_verify"),
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"postalCode_hasError":true}); return; }
    }
    else if(stateVar==="phoneNumber"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "phoneNumber"          : eventTMP,
        "phoneNumber_hasError" : (eventTMP.trim() === "") ? true : false,
        "btn_next_state"       : this.NSInforString("CustomerConfirm_btn_verify"),
      });
      if(this.state.countryResidence_id==="GR"){
        if(eventTMP.trim().startsWith("69")===true){this.setState({ "isMobile":  true }); }
        else                                       {this.setState({ "isMobile":  false });}
      }
    }
    else{
      this.setState({ [stateVar] : eventTMP, });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email")                            { return wu_Utilities.wu_verifyEmail(val); }
    if(key==="homeAddress")                      { val = val.replace(/ /i, ""); return wu_Utilities.offline_validate_homeAddress(val);  }
    if(key==="cityResidence")                    { val = val.replace(/ /i, ""); return wu_Utilities.offline_validate_cityResidence(val);  }
    if(key==="phone_landline")                   { return wu_Utilities.offline_validate_phone_landline(val);  }
    if(key==="phone_mobile")                     { return wu_Utilities.offline_validate_phone_mobile(val);  }
    if(key==="8digitregisterpin")                { return wu_Utilities.offline_validate_8digitregisterpin(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  shouldAllow_updateMobileTriggerOTP(aDate){
    let methName = filename+"shouldAllow_updateMobileTriggerOTP ";
    if(api.print_logs){console.log(methName);}

    if(aDate === null || (typeof aDate ==="undefined") || aDate===""){
      console.log(methName+"true1");
      return true;
    }
    try{
      var t2     = aDate.getTime();
      var t1     = (new Date()).getTime();
      let diffMS = Math.abs(parseInt(t2-t1));
      if(diffMS > api.OTPRetryPeriodMS){
        console.log(methName+"true2");
        return true;
      }
    }catch(err){
      console.log('err='+err);
    }

    console.log(methName+"false");
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG2"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups successConfirm-----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_successConfirm_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_successConfirm_isOpen" : true,
        "dialog_successConfirm_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_successConfirm_btn_add(){
    let methName = filename+"dialog_successConfirm_btn_add ";
    if(api.print_logs){console.log(methName);}

    var parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    //---------------------
    //newCustomer filtering---After Login
    //---------------------
    localStorage.setItem("LoginPage_flow",          "true");
    localStorage.setItem("TransferOnlineLogin_flow","false");
    var newRegistrationFlow = wu_Utilities.newRegistrationFlow_flag_get(api.print_logs,parserObject_validatecustomer);
    if(api.print_logs){console.log(methName+"newRegistrationFlow screen=" + newRegistrationFlow["screen"]);}
    try { localStorage.setItem("newRegistrationFlow",newRegistrationFlow["flow"]); } catch(err){;}
    if(newRegistrationFlow["screen"]==="CustomerConfirm"){ history.push(wu_Utilities.getNavigationURLs("CustomerConfirm"));   return; }
    if(newRegistrationFlow["screen"]==="TransferOnline1"){ history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));   return; } //Be Carefull
    if(newRegistrationFlow["screen"]==="Bills")          { history.push(wu_Utilities.getNavigationURLs("Bills"));             return; } //Be Carefull
    if(newRegistrationFlow["screen"]==="RegisterInfo")   { history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }

    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
    // console.log("LoginPage_flow="+localStorage.getItem("LoginPage_flow"));
    // if(localStorage.getItem("LoginPage_flow")==="true"){
    //   //+++++++++++++++
    //   //Goto Controller
    //   //+++++++++++++++
    //   //localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    //   history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
    // }
    // else if(localStorage.getItem("TransferOnlineLogin_flow")==="true"){
    //   //+++++++++++++++
    //   //Goto Controller
    //   //+++++++++++++++
    //   //localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    //   history.push(wu_Utilities.getNavigationURLs("TransferOnline2"));
    // }
    // else{
    //   //Should NEVER HAPPEN
    //   //+++++++++++++++
    //   //Goto Controller
    //   //+++++++++++++++
    //   //localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    //   history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
    // }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( CustomerConfirm_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    CustomerConfirm_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    CustomerConfirm_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
}
CustomerConfirm.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(CustomerConfirmStyle)(CustomerConfirm)
);
